import { PrivacyCenterTrackingPurposePreview } from '@main/cm-types';
import { PurposeSchema } from '@main/sombra-types';
import { indexBy } from '@main/utils';

import { Preference, Purpose } from '../CommunicationsPreferences/components';

/**
 * Transform a user's purposes/preferences to purposes to be displayed in a form
 *
 * @param purposes - A user's set purposes/preferences
 * @param configuredCommunicationPurposes - Purposes configured for a particular organization
 * @returns a user's purposes/preferences to be displayed
 */
export function transformPurposesToFormPurposes(
  purposes: PurposeSchema[],
  configuredCommunicationPurposes: PrivacyCenterTrackingPurposePreview[],
): Record<string, Purpose> {
  const existingPurposes = indexBy(
    configuredCommunicationPurposes,
    'trackingType',
  );

  return purposes.reduce(
    (acc, { purpose, consent, preferences }) => {
      if (!existingPurposes[purpose]) {
        return acc;
      }

      const validPreferences = preferences
        ? preferences.reduce((accPreferences, { topic, choice }) => {
            const isValidTopic = (
              existingPurposes[purpose].preferenceTopics || []
            ).find((pref) => pref.slug === topic);

            return isValidTopic
              ? { ...accPreferences, [topic]: choice }
              : accPreferences;
          }, {} as Preference)
        : {};

      return {
        ...acc,
        [purpose]: {
          consent,
          preferences: validPreferences,
        },
      };
    },
    {} as Record<string, Purpose>,
  );
}
